import React, { createContext, useContext } from 'react';
import GlobalAttendanceNfcListener from 'components/attendance/GlobalAttendanceNfcListener';
import { useAttendanceNfcScan } from 'hooks/useAttendanceNfcScan';
import { usePermissions } from 'hooks/usePermissions';

const AttendanceNfcContext = createContext(null);

export function AttendanceNfcProvider({ children }) {
  const { canViewAttendance } = usePermissions();
  const scanState = useAttendanceNfcScan();

  if (!canViewAttendance) {
    return children;
  }

  return (
    <AttendanceNfcContext.Provider value={scanState}>
      <GlobalAttendanceNfcListener />
      {children}
    </AttendanceNfcContext.Provider>
  );
}

export function useAttendanceNfc() {
  return useContext(AttendanceNfcContext);
}
